import React, { useState, useRef } from "react";


import BCButtonWithDropdown from "./BCButtonWithDropdown";
import FlameButtonWithDropdown from "./FlameButtonWithDropdown";
import CoinButtonWithDropdown from "./CoinButtonWithDropdown";
import BoltButtonWithDropdown from "./BoltButtonWithDropdown";
import "./popupsright.css";

const StatsCard = () => {

  return (
    <div className="rightmenu-card-stats stats-card">
      <div className="stats">
        <BCButtonWithDropdown />
        <FlameButtonWithDropdown />
        <CoinButtonWithDropdown />
        <BoltButtonWithDropdown />
      </div>
    </div>
  );
};

export default StatsCard;
